module.exports = __webpack_public_path__ + "static/media/BestResaleValueAwards.87bc8686.png";